import { Component, OnInit, Inject } from '@angular/core';
import { DropzoneConfigInterface } from 'ngx-dropzone-wrapper';
import { mediaDB } from 'src/app/shared/tables/media';
import { FormBuilder, FormGroup, Validators} from '@angular/forms';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
declare var $: any;
@Component({
  selector: 'app-media',
  templateUrl: './media.component.html',
  styleUrls: ['./media.component.scss']
})
export class MediaComponent implements OnInit {

  public files = []
  public Form: FormGroup;

  imageObj: File;
  imageUrl: null;
  submitted = false;
  message = null;
  class = null;
  action = null;

  constructor(private formBuilder: FormBuilder, private http: HttpClient, private ActivatedRoute: ActivatedRoute, private router: Router, @Inject('API_ENDPOINT') private api_endpoint: string) {
    // this.media = mediaDB.data;
  }

  ngOnInit() {
    this.Form = this.formBuilder.group({
      file: ['', Validators.required],
    })

    this.http.get<any>(this.api_endpoint+'/uploads/').subscribe(
      data => {
        this.files = data.data;
        /* data.data.map(item => {
          return {
            img: "<img src='https://hkbkeduin.s3.amazonaws.com/"+data.data.image+"' class='imgTable' >",
            file_name: data.data.image,
            url: "https://hkbkeduin.s3.amazonaws.com/"+data.data.image,
        }
      }).forEach(item => this.files.push(item)); */
    },
    (err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
        console.log("Client-side error occured.");
      } else {
        console.log("Server-side error occured.");
      }
  });


  }
  public settings = {
    actions: {
      position: 'right',
      add: false,
      edit: false,
      delete: false
    },
    
    columns: {
      image: {
        title: 'Image',
        type: 'html',
      },
      imagename: {
        title: 'File Name'
      },
      /* url: {
        title: 'URL'
      }, */
      nodeurl: {
        title: 'URL'
      },
    },
  };

  public config1: DropzoneConfigInterface = {
    clickable: true,
    maxFiles: 1,
    autoReset: null,
    errorReset: null,
    cancelReset: null,
  };

  public onUploadInit(args: any): void { }

  public onUploadError(args: any): void { }

  public onUploadSuccess(args: any): void {
    window.location.reload();
   }
  

  onImagePicked(event: Event): void {
    const FILE = (event.target as HTMLInputElement).files[0];
    this.imageObj = FILE;
   }
   get f() { return this.Form.controls; }

   onImageUpload() {
    this.submitted = true;

    if (this.Form.invalid) {
      return;
    }
    // if(this.imageObj.type.search("image") != -1){
    //   if(this.imageObj.size > 1000000){
    //     alert('Image size should be lesser than 1MB');
    //     return false;
    //   }
    // }else if(this.imageObj.type.search("application") != -1){
    //   if(this.imageObj.size > 10485760){
    //     alert('File size should be lesser than 10MB');
    //     return false;
    //   }
    // }

    const imageForm = new FormData();
    imageForm.append('image', this.imageObj);
    imageForm.append('admin', sessionStorage.getItem('adminName'),);
    
      // alert(this.imageObj.name);     
      this.http.get<any>(this.api_endpoint+'/uploadsfindbyimagename/'+ this.imageObj.name).subscribe(
      data => {
        console.log(data);
        if(data.data && data.data.imagename == this.imageObj.name){
          if(confirm("Image already exists, do you want to replace image?")){
            /* this.http.post<any>(this.api_endpoint+'/uploadToS3/', imageForm).subscribe(
            res => {
              console.log(res);
              if(res.status == '500'){
                this.message = res.message;
                this.class = 'btn btn-primary';
                return
              }else{
                this.message = 'Successfully Uploaded url: '+res.message.toLowerCase();
                this.class = 'btn btn-success';
                this.ngOnInit();
              } 
            },
            (err: HttpErrorResponse) => {
              if (err.error instanceof Error) {
                console.log("Client-side error occured.");
              } else {
                console.log("Server-side error occured.");
              }
            }); */
            imageForm.append('_id', data.data._id);
            this.http.post<any>(this.api_endpoint+'/uploadToDiskstorage/', imageForm).subscribe(
            res => {
              if(res.status == '500'){
                this.message = res.message;
                this.class = 'btn btn-primary';
                return
              }else{
                this.message = 'Successfully Uploaded url: ';
                this.class = 'btn btn-success';
                this.ngOnInit();
              } 
            },
            (err: HttpErrorResponse) => {
              if (err.error instanceof Error) {
                console.log("Client-side error occured.");
              } else {
                console.log("Server-side error occured.");
              }
            });
          } 
        }else{
          /* this.http.post<any>(this.api_endpoint+'/uploadToS3/', imageForm).subscribe(
            res => {
              console.log(res);
              if(res.status == '500'){
                this.message = res.message;
                this.class = 'btn btn-primary';
                return
              }else{
                this.message = 'Successfully Uploaded url: '+res.message.toLowerCase();
                this.class = 'btn btn-success';
                this.ngOnInit();
              } 
            },
            (err: HttpErrorResponse) => {
              if (err.error instanceof Error) {
                console.log("Client-side error occured.");
              } else {
                console.log("Server-side error occured.");
              }
            }); */
            this.http.post<any>(this.api_endpoint+'/uploadToDiskstorage/', imageForm).subscribe(
              res => {
                if(res.status == '500'){
                  this.message = res.message;
                  this.class = 'btn btn-primary';
                  return
                }else{
                  this.message = 'Successfully Uploaded url: ';
                  this.class = 'btn btn-success';
                  this.ngOnInit();
                } 
              },
              (err: HttpErrorResponse) => {
                if (err.error instanceof Error) {
                  console.log("Client-side error occured.");
                } else {
                  console.log("Server-side error occured.");
                }
              });
        }
        
      },
      (err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
      console.log("Client-side error occured.");
      } else {
      console.log("Server-side error occured.");
      }
      });
   }

}
